export default "__VITE_ASSET__Bpr2hHSn__"